import { Injectable } from '@angular/core';
import { DinaUppgifterBFFService } from '../../bff/services/dina-uppgifter.bff';
import { ValutakursParam } from '../../berakningshjalpen/shared/classes/form-underlag.class';
import { RegelmotorInput } from '../../berakningshjalpen/shared/models/regelmotorInput.model';
import { DinaUppgifter } from '../../berakningshjalpen/shared/models/dina-uppgifter.model';
import { InfotexterInput } from '../../berakningshjalpen/shared/models/infotexterInput.model';

@Injectable({
  providedIn: 'root'
})
export class BFFApiService {
  constructor(public gateway: DinaUppgifterBFFService) {
  }

  getDittUnderlag(): Promise<DinaUppgifter> {
    return this.gateway.getDittUnderlagViewModel();
  }

  getInfotexter(infotexterInput: InfotexterInput): any {
    return this.gateway.getInfotexter(infotexterInput);
  }

  getValutakurser(valutaParam: ValutakursParam) {
    return this.gateway.getValutaKurser(valutaParam);
  }

  getResultat(regelmotorInput: RegelmotorInput) {
    return this.gateway.getResultat(regelmotorInput);
  }

}
